import VueSocket from 'vue-3-socket.io'
import { io } from 'socket.io-client'
import SystemAPI from '@/apis/portal/systemAPI'

// Lắng nghe sự kiện
// this.$socket.subscribe('EVENT_NAME', (data) => {
//   //
// });

// Hủy lắng nghe
// this.$socket.unsubscribe('EVENT_NAME');

// EVENT_NAME lấy tại WebSocketEvent
export const WebSocketEvent = Object.freeze({
  ServerConnected: 'ServerConnected', // Server đã kết nối
  DebugEvent: 'debug_event', // Test
  QueueMessageImported: 'QueueMessageImported', // Nhập khẩu thành công message queue
})

export const initSocket = async app => {
  const token = await getWebSocketToken()

  if (token) {
    const options = {
      transports: ['websocket'],
      extraHeaders: { Authorization: `Bearer ${token}` },
      reconnectionDelayMax: window._webSocket.reconnectionDelayMax || 10000,
      query: `token=${token}`,
    }
    app.use(new VueSocket({
      connection: io(window._webSocket.Url, options),
      debug: window._webSocket.debug,
    }))
  }
}

/**
 * Lấy token
 * xử lý retry phòng khi lỗi thì thử lại
 * @returns
 */
const getWebSocketToken = async () => {
  const loop = (window._webSocket.retry || 0) + 1
  let token = null

  for (let i = 0; i < loop; ++i) {
    try {
      const res = null // await SystemAPI.getWebSocketToken()
      if (res?.Token) {
        token = res.Token
        break
      }
    } catch (error) {
      console.log(error)
    }
  }

  return token
}
